var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.674,
    height: 17.756,
    viewBox: "0 0 23.674 17.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "profile_information") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00a0e9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.482,10.249H24.826V7.765l-3.418-.052.018,2.537H11.157l.07-2.537-3.347.052V10.3L6.19,10.249A1.692,1.692,0,0,0,4.5,11.94V23.777A1.692,1.692,0,0,0,6.19,25.468H26.482a1.692,1.692,0,0,0,1.691-1.691V11.94A1.692,1.692,0,0,0,26.482,10.249ZM22.254,8.558h1.691V11.94H22.254Zm-10.992,5.76a2.2,2.2,0,0,1,1.85,2.431,2.2,2.2,0,0,1-1.85,2.431,2.2,2.2,0,0,1-1.85-2.431,2.2,2.2,0,0,1,1.85-2.431ZM8.726,8.558h1.691V11.94H8.726ZM7.6,22.042s.2-1.608.656-1.912a6.485,6.485,0,0,1,1.767-.506s.851.909,1.212.909,1.212-.909,1.212-.909a6.465,6.465,0,0,1,1.768.506c.535.357.669,1.912.669,1.912H7.6Zm17.192-.8h-7.61v-.846h7.61Zm0-1.691h-7.61V18.7h7.61Zm0-1.691h-7.61v-.846h7.61Zm0-1.691h-7.61v-.846h7.61Z",
    transform: "translate(-4.499 -7.712)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileInformation);
export default __webpack_public_path__ + "static/media/profile_information.db53b617d07c70461109b3e62522682d.svg";
export { ForwardRef as ReactComponent };